<template>
  <b-modal
    id="modal-field"
    :title="editMode == true ? $t('general.edit') : $t('general.add_application')"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.save')"
    cancel-variant="outline-secondary"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmit"
  >
    <validation-observer ref="materialAddModal">
      <b-row class="material">

        <b-col md="12">
          <b-form-group :label="$t('brigade')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('brigade')"
              rules="required"
            > -->
              <v-select
                v-model="goods.brigade"
                label="title"
                :options="GET_BRIGADE.results"
                id="goods_brigade_select"
              >
                <li slot="list-footer" class="pagination">
                  <button :disabled="!GET_BRIGADE.previous" @click="previousBridge">
                    {{ $t("prev") }}
                  </button>
                  <button :disabled="!GET_BRIGADE.next" @click="nextBridge">
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>
              <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('reference.categoriya')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('reference.categoriya')"
              rules="required"
            > -->
              <v-select
                v-model="goods.category"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="GET_PRODUCT_CATEGORIES"
                @input="materialTypeGetByCategory"
                id="goods_category_select"
              />
              <!-- <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('table.product_type')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('table.product_type')"
              rules="required"
            > -->
              <v-select
                v-model="goods.title"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="GET_MATERIALS.results"
                :filterable="false"
                @input="materialGet"
                @search="onSearch1"
                id="goods_title_select"
              >
                <li slot="list-footer" class="pagination">
                  <button :disabled="!GET_MATERIALS.previous" @click="previous()">
                    {{ $t("prev") }}
                  </button>
                  <button :disabled="!GET_MATERIALS.next" @click="nextFunc()">
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>

              <!-- <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('nomenclature')">
            <validation-provider
              #default="{ errors }"
              :name="$t('nomenclature')"
              rules="required"
            >
              <v-select
                v-model="goods.good_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="GET_MATERIALS_TABLE_ID.results"
                :filterable="false"
                @search="onSearch"
                @input="onGoodSelected"
                label="value"
                id="goods_good_id_select"
              >
                <li slot="list-footer" class="pagination">
                  <button
                    :disabled="!GET_MATERIALS_TABLE_ID.previous"
                    @click="previousTableId()"
                  >
                    {{ $t("prev") }}
                  </button>
                  <button
                    :disabled="!GET_MATERIALS_TABLE_ID.next"
                    @click="nextTableId()"
                  >
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group :label="$t('unit_of_measurement')">
              <b-form-input
                :disabled="true"
                :value="goods && goods.good_id && goods.good_id.unity ? goods.good_id.unity : ''"
                type="text"
                id="goods_good_id_unity_input"
              />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group :label="$t('amount')">
            <validation-provider
              #default="{ errors }"
              :name="$t('amount')"
              rules="required"
            >
              <b-form-input
                v-model="goods.count"
                type="text"
                @input="formatPrice(goods.count, 'count')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
                id="goods_count_input"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

         <b-col md="12">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea v-model="goods.comment" type="text" id="goods_comment_textarea" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BModal } from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@core/utils/validations/validations";
import priceFormatMixin from "@/mixins/priceFormatMixin";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BModal,
  },
  props: {
    materialss: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  mixins: [priceFormatMixin],
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      getMaterial: [],

      search: "",
      search1: "",

      goods: {
        id: null,
        brigade: null,
        category: null,
        title: null,
        good_id: null,
        count: null,
        comment: null
      },
      editMode: false,
    };
    // ===============  PRIMARY_DATA_SECTION END ===============
  },
  computed: {
    ...mapGetters("materials", [
      "GET_MATERIALS",
      "GET_MATERIALS_TABLE_ID",
      "GET_PRODUCT_CATEGORIES",
    ]),
    ...mapGetters("brigade", [
      "GET_BRIGADE",
    ]),

   
  },
  async mounted() {
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_PRODUCT_CATEGORIES({ mini: true });
    this.GET_PRODUCT_CATEGORIES.unshift({
      id: null,
      title: this.$i18n.locale == "ru" ? "Все" : "Barchasi",
    });
    await this.FETCH_BRIGADE();
    // ===============  PRIMARY_REQUESTS_SECTION END ===============
  },
  methods: {
    ...mapActions("materials", [
      "FETCH_MATERIALS_TABLE_ID",
      "FETCH_PRODUCT_CATEGORIES",
      "FETCH_MATERIALS",
    ]),
    ...mapActions("brigade", [
      "FETCH_BRIGADE",
    ]),




    async previousTableId() {
      if (this.GET_MATERIALS_TABLE_ID.previous) {
        const page = this.GET_MATERIALS_TABLE_ID.previous;

        await this.FETCH_MATERIALS_TABLE_ID({
          product: this.goods && this.goods.title && this.goods.title.id ? 
          this.goods.title.id : null,
          page: page,
          pagination: "number",
          search: this.search
        });
      }
    },

    async nextTableId() {
      if (this.GET_MATERIALS_TABLE_ID.next) {
        const page = this.GET_MATERIALS_TABLE_ID.next;

        await this.FETCH_MATERIALS_TABLE_ID({
          product: this.goods && this.goods.title && this.goods.title.id ? 
          this.goods.title.id : null,
          page: page,
          pagination: "number",
          search: this.search
        });
      }
    },

    async previous() {
      if (this.GET_MATERIALS.previous) {
        const page = this.GET_MATERIALS.previous;

        await this.FETCH_MATERIALS({ 
          category: this.goods && this.goods.category 
          && this.goods.category.id ? this.goods.category.id : null,
          page: page, 
          pagination: "number",
        });
      }
    },

    async nextFunc() {
      if (this.GET_MATERIALS.next) {
        const page = this.GET_MATERIALS.next;

        await this.FETCH_MATERIALS({ 
          category: this.goods && this.goods.category && this.goods.category.id ?
           this.goods.category.id : null,
          page: page, 
          pagination: "number",
        });
      }
    },

    async previousBridge() {
      if (this.GET_BRIGADE.previous) {
        const page = this.GET_BRIGADE.previous;

        await this.FETCH_BRIGADE({ page: page, pagination: "number" });
      }
    },

    async nextBridge() {
      if (this.GET_BRIGADE.next) {
        const page = this.GET_BRIGADE.next;

        await this.FETCH_BRIGADE({ page: page, pagination: "number" });
      }
    },



    onGoodSelected(value){
      // if(this.goods.title == '' || this.goods.title == null || this.goods.category == '' || this.goods.category == null){
        if(value && value.product && value.product.id && value.product.title && value.product.category && value.product.category.id && value.product.category.title){
          this.goods.title = {id: value.product.id, title: value.product.title}
          this.goods.category = {id: value.product.category.id, title: value.product.category.title}
        }
      // }
    },






    // ===============  SEARCH_SECTION START ===============
    async onSearch(query) {
      this.search = query;
      await this.FETCH_MATERIALS_TABLE_ID({
        product: this.goods && this.goods.title && this.goods.title.id ?
        this.goods.title.id : null,
        search: query,
        pagination: "number", 
      });
    },
    async onSearch1(query) {
      await this.FETCH_MATERIALS({
        search: query,
         pagination: "number",
        });
    },
    // ===============  SEARCH_SECTION END ===============










    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "count") {
          this.goods.count = currency;
        }
      }
      return 0;
    },







    

    // ===============  SHOW_MODAL_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode;
      this.goods = {
        id: null,
        brigade: null,
        category: null,
        title: null,
        good_id: null,
        count: null,
        comment: null,
      };

      if (!this.materialss) {
        return;
      }

      if (typeof this.materialss === "object" && this.materialss !== null) {
        if (!this.materialss) {
          return;
        }
        this.goods.id = this.materialss.id;
        this.goods.brigade = this.materialss.brigade;
        this.goods.category = this.materialss.category;
        this.goods.title = this.materialss.title;
        this.goods.good_id = this.materialss.good_id;
        this.goods.count = this.materialss.count;
        this.goods.comment = this.materialss.comment;
      }
    },
    // ===============  SHOW_MODAL_SECTION END ===============










    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.$refs.materialAddModal.validate().then(async (success) => {
        if (!success) {
          this.$_errToast({ message: this.$t("all_fields_are_required") });
          return;
        }
        try {
          this.$nextTick(() => {
            this.$route.params.editMode = false;
            this.$emit("onSave", this.goods);
            this.$bvModal.hide("modal-field");
          });
          this.$_okToast();
        } catch (err) {
          console.log(err);
          // this.$_errToast('Error')
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============










    // ===============  MATERIAL_GET_SECTION START ===============
    async materialTypeGetByCategory(data) {
      if (data.id == 0) {
        await this.FETCH_MATERIALS({ pagination: "number" });
      } else {
        await this.FETCH_MATERIALS({ 
          category: data.id, 
          pagination: "number",
        });
      }
    },
    async materialGet(data) {
      if (!data) {
        this.getMaterial = [];
        // this.app.good_id = null;
      } else {
        await this.FETCH_MATERIALS_TABLE_ID({
          product: data.id,
          pagination: "number",
        });
      }
      
      if(data.category && data.category.id && data.category.title){
        // if(this.goods.category == '' || this.goods.category == null){
          // this.goods.title = {id: data.product.id, title: data.product.title}
          this.goods.category = {id: data.category.id, title: data.category.title}
        // }
      }
    },
    // ===============  MATERIAL_GET_SECTION END ===============





  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}


.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
